import { render, staticRenderFns } from "./MatchInfo.vue?vue&type=template&id=724e1173&scoped=true&"
import script from "./MatchInfo.vue?vue&type=script&lang=js&"
export * from "./MatchInfo.vue?vue&type=script&lang=js&"
import style0 from "./MatchInfo.vue?vue&type=style&index=0&id=724e1173&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e1173",
  null
  
)

export default component.exports